module.exports = __webpack_public_path__ + "./assets/b9035d085ff21b03b0e3968091db0278.woff";